export default import.meta.ROLLUP_FILE_URL_VWwheoQHW_e8UcRiND$XOg;